<template>
    <div class="home">
        <h1 class="top-title">FlexiSwiftLoan</h1>        
        <div class="top">                
            <h2 class="element-title">
                    <img :src="element.logo" alt="">
                    <span v-text="element.name"></span>
                </h2>
                <div class="info">
                    <div class="caption">Loan Amount</div>
                    <div class="amount" v-text="`₹${element.minAmount}-${element.maxAmount}`"></div>
                    <div class="other-info">
                        <div class="oi-left">
                            <div class="left-text">
                                <span class="left">Loan Term:</span>
                                <span class="right">&nbsp;91-180days</span>
                            </div>
                            <div class="left-text">
                                <span class="left">Interest Rate:</span>
                                <span class="right" v-text="`  ${element.rate}%/Day`"></span>
                            </div>
                        </div>
                    </div>
                    <a v-if="element.isFull == 0" @click="before_apply(element.id)"  class="btn-apply active">Apply</a>       
                </div>                                       
        </div>            
        <!-- <div class="certification">
            <h2 class="c-title">Qualification certification</h2>
            <div class="img-container">
                <img src="../../../assets/images/auth-process.png" alt="">
            </div>
        </div>         -->
    </div>
</template>
<style lang="less" scoped>
    @import "~assets/less/icon.less";
    // .certification{
    //     margin-top: 50px;
    //     .c-title{
    //         font-size: 28px;
    //         text-align: center;
    //         color:#333;
    //         margin:40px 0;
    //     }
    //     .img-container{
    //         width: 646px;
    //         height: 254px;
    //         margin:0 auto;
    //         img{
    //             width: 100%;
    //             height: 100%;
    //         }
    //     }
        
    // }
    .top-title{
            margin:50px 0;
            color:#333;
            text-align: center;
            font-size: 40px;
        }
    .top{
        
        padding:50px 35px;
        width: 620px;
        height: 570px;
        background:#BE9060;
        background-size:100% 100%;
        border-radius: 20px;
        margin:0 auto;
        .element-title{            
            width: 640px;
            height:85px;
            line-height: 65px;
            display: flex;
            align-items: center;
            justify-content: center;  
            padding-top: 20px;          
            // background:#BE9060;                    
            img{
                width: 64px;
                height: 64px;
                margin-right: 20px;
            }
            span{
                color:#fff;
                font-size: 40px;
            }
        }
        .info{
            padding: 30px 50px;
            .caption{
                font-size: 32px;
                color:#fff;
                text-align:center;
                margin-top: 10px;
            }
            .amount{
                font-size: 50px;
                color:#fff;
                text-align: center;
                font-weight: 700;
                margin-top: 30px;
            }
            .other-info{
                overflow: hidden;
                display: flex;     
                align-items: center;
                margin-top: 20px;
                .oi-left{                            
                    width: 100%;
                    text-align: center;
                    .left-text{
                        .left{
                            font-size: 30px;
                            color:#fff;
                        }
                        .right{
                            color:#fff;
                            font-size: 30px;                                    
                        }
                    }
                }                
            }            
        }    
           
    }
    .btn-apply{
                display:block;
                width: 420px;
                height: 100px;
                line-height: 100px;
                color:#fff;
                font-size: 34px;
                text-align:center;
                background:#fff;
                border:1px solid #f3dec6;
                color:#BE9060;
                border-radius: 100px;  
                margin:40px auto 0 auto;
                
                // margin-top: 50px;
                // margin-left: 100px;              
    } 
</style>
<script>
import { getOrders } from '@api/index'
import { useLoading } from 'vue-loading-overlay'
import {useRouter} from 'vue-router'
import { computed } from 'vue'
export default {    
    props:{
        imgList:{
            type:Array,
            default:()=>{}
        },
        money: String ,
        logined: String,
        list:[]     
    },
    setup(props) {
        const loading = useLoading()
        const router = useRouter()
        const element = computed(()=>{
            return props['list'][0]
        })
        const before_apply = (pid) => {            
            const loader = loading.show({
                container: null
            })
            getOrders().then((resp)=>{
                loader.hide()
                const list = resp.data.filter((element)=>{
                    return (pid == element.id) && (element.orderState == '1' || element.orderState == '2' || element.orderState == '4' || element.orderState == '6' || element.orderState == '8')
                })
                if(list.length > 0) {
                    router.push({
                        path:'/orders'
                    })
                } else {
                    router.push({
                        "path":'/auth/index',
                        "query":{
                            "pid":pid
                        }
                    })
                }
            })
        }
        return {
            before_apply,
            element
        }
        // money = ref('')
        // const money = props.money
    
        // return {
        //     money
        // }
    }    
}
</script>